module.exports = __webpack_public_path__ + "media/images/nereport/icon_nega1-979bf553b9742b6806922a200ab49efc.svg";